import React from 'react';
import logo from '../../../assets/images/squire-logo-light.svg';

const LightLogo = () => (
  <img src={logo} alt="Squire" />
);

export default LightLogo;



// WEBPACK FOOTER //
// ./src/app/components/LightLogo.jsx